import db from '@/db';

// Helper central para saber se o modo treinamento está ativo (Fase 8)
export async function isTrainingMode() {
  const c = await db.config.get('trainingMode');
  return !!c?.value;
}

export async function setTrainingMode(enabled) {
  await db.config.put({ key: 'trainingMode', value: !!enabled });
}

// Filtra registros isTraining=true das estatísticas financeiras reais
export function excludeTraining(items) {
  return (items || []).filter((i) => !i.isTraining);
}
